// import css from './catalog.module.css'
// import img1 from '../../img/manuscript.png'
// import img2 from '../../img/saleNewOne.png'
// import img3 from '../../img/pic2.png'

// export default function FirstBlockMan() {

//     return(
//         <div className={css.wrapManus}>
//          <div className={css.wrapFirstManus}>
//             <div className={css.someTextWramMan}>
//                 <h3 className={css.manuscriptH3}>Рукописи</h3>
//                 <p className={css.manuscriptP}>читай першим! </p>
//             </div>
//             <img src={img1} className={css.firstImg}/>
//             <img src={img2} className={css.secondImg}/>
//             <img src={img3} className={css.threImg}/>
//          </div>
//         </div>
//     )
// }
import css from "./catalog.module.css";
import img1 from "../../img/manuscript.png";
import img2 from "../../img/saleNewOne.png";
import img3 from "../../img/pic2.png";

function getYearLabel(year) {
  const value = Number(year);

  if (value === 1) return "1 рік";
  if (value >= 2 && value <= 4) return `${value} роки`;

  return `${value} років`;
}

export default function FirstBlockMan({
  yearOptions = [],
  selectedYear = "",
  onYearChange,
}) {
  return (
    <div className={css.wrapManus}>
      <div className={css.wrapFirstManus}>
        <div className={css.someTextWramMan}>
          <h3 className={css.manuscriptH3}>Рукописи</h3>
          <p className={css.manuscriptP}>читай першим!</p>

          <select
            className={css.manuscriptYearSelect}
            value={selectedYear}
            onChange={(e) => onYearChange(e.target.value)}
          >
            <option value="">Усі роки</option>

            {yearOptions.map((year) => (
              <option key={year} value={year}>
                {getYearLabel(year)}
              </option>
            ))}
          </select>
        </div>

        <img src={img1} className={css.firstImg} alt="" />
        <img src={img2} className={css.secondImg} alt="" />
        <img src={img3} className={css.threImg} alt="" />
      </div>
    </div>
  );
}
